import LocalModal from 'components/base/local-modal';
import React from 'react';
import './style.scss';

const LearnMoreModal = ({ show, onClose }: { show: boolean; onClose: () => void }) => {
  return (
    <LocalModal isOpen={show} onRequestClose={onClose}>
      <div>
        <div className='top-0 left-0 rounded-md blur'></div>
        <div className='py-4 bg-white mt-[180px]'>
          <h2 className='text-[20px] font-semibold my-2'>Enjoy your favorite meals all day long</h2>
          <p className='text-[#434547] !leading-[25.2px] text-sm'>
            At cum vel viverra nisi. Volutpat magna proin risus id sit ut. In neque dictum proin
            diam. Augue tempor facilisi tempus id. A orci eget quis non faucibus lobortis tristique.
            Eget enim feugiat adipiscing felis vulputate egestas velit ut aliquet. Leo dolor cursus
            tristique in justo vulputate enim nibh in. Pellentesque nulla ut at maecenas sed et
            aliquam. Ultricies est commodo in turpis et tempus. Quis hendrerit lacus eu fames felis
            diam.
          </p>
        </div>
      </div>
    </LocalModal>
  );
};

export default LearnMoreModal;
